export const environment = {
  production: true,
  hmr: false,
  elements: false,
  recruiteeApi: 'https://kcap.recruitee.com/api/offers/',
};
